import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import classNames from "classnames";
import * as c from "./emailMarketingSection.module.scss";
import EmailCaptureForm from "./emailCaptureForm";

const EmailMarketingSection = ({
  heading,
  subheading,
  leftImage,
  rightImage,
  logo,
  emailCapture,
  isBlog = false,
  businessTypes,
}) => {
  return (
    <section className={classNames(c.section, isBlog && c.blogSection)}>
      <div className={c.content}>
        <h3 className={classNames(c.heading, "h3")}>{heading}</h3>
        <p className={classNames(c.subheading, "p3")}>{subheading?.subheading}</p>
      </div>

      <div className={c.container}>
        <div className={c.formWrapper}>
          <EmailCaptureForm formSource="mt_100_email_capture" {...emailCapture} businessTypes={businessTypes} />

          {logo?.gatsbyImageData && (
            <div className={c.logo}>
              <GatsbyImage image={logo.gatsbyImageData} alt="" />
            </div>
          )}
        </div>

        <div className={c.imagesContainer}>
          {leftImage?.gatsbyImageData && (
            <div className={c.leftImage}>
              <GatsbyImage image={leftImage.gatsbyImageData} alt="" objectFit="contain" />
            </div>
          )}

          {rightImage?.gatsbyImageData && (
            <div className={c.rightImage}>
              <GatsbyImage image={rightImage.gatsbyImageData} alt="" objectFit="contain" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default EmailMarketingSection;
